import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio34: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"aspect-ratio-3-4, portrait"} maskId="square-filled-radius-0-stroke-1-IconAspectRatio34"><path d="M4 2V22H20V2H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAspectRatio34;
